import React, { useRef, useEffect, useState } from 'react';
import propTypes from 'prop-types';
import { C } from 'shared/helpers';

import Styles from './ProductEditor.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Select } from 'components/Template';
import NumberFormat from 'react-number-format';
import { useSelector } from 'react-redux';
import { useEffectWithPrevious } from 'shared/hooks';
import MessageModal from 'components/MessageModal/MessageModal';

export default function ProductEditor({
  form,
  open,
  setter,
  close,
  renderables,
  submit,
  etecStatus,
  changeEtec,
  availableEtecs,
}) {
  const block = useRef(false);
  const errorProduto = useSelector((state) => state.produtos.error);
  const errorMessage = useSelector((state) => state.produtos.errorMessage);
  const loadingProduto = useSelector((state) => state.produtos.loading);
  const [pageError, setPageError] = useState();
  const initialized = useRef(false);
  useEffect(() => {
    if (!initialized.current) initialized.current = true;
    else if (!loadingProduto) {
      block.current = false;
      if (!errorProduto) {
        close();
      }
    }
  }, [loadingProduto, errorProduto, close]);

  useEffectWithPrevious(
    ([previousError]) => {
      if (previousError === null && errorProduto) {
        setPageError(errorMessage);
      }
    },
    [errorProduto],
  );
  useEffect(() => {
    if (open) block.current = false;
  }, [open]);
  const { ProductEditor, Open, Header, Row, Container } = Styles;
  return (
    <div className={C(ProductEditor, [open, Open])}>
      <main className={C('scrollable', [open, Open])}>
        <header onClick={close}>
          {form.id || form._id ? 'Editar produto' : 'Criar novo produto'}
          <div id='close_btn'>
            <FontAwesomeIcon icon={faTimes} />
          </div>
        </header>
        <form>
          <header>
            <p>Nome</p>
            <input
              name={'nome'}
              onChange={setter}
              value={form.nome}
              placeholder={'Nome'}
            />
            <p>Marca</p>
            <input
              name={'classificacao'}
              onChange={setter}
              value={form.classificacao}
              placeholder={'Marca'}
            />
            {changeEtec && (
              <>
                <p>ETEC</p>
                <Select
                  id='etec_selector'
                  valueRef={form.user_id}
                  setValueRef={(id) =>
                    setter({ target: { value: id, name: 'user_id' } })
                  }
                  options={availableEtecs.map((e) => ({
                    label: e.name,
                    value: e.id,
                  }))}
                />
              </>
            )}
          </header>
          <hr />
          <div className={Header}>Elementos</div>
          {renderables
            .map((x, y) => (!(y % 2) ? [x, renderables[y + 1]] : null))
            .filter((z) => z !== null)
            .map((a) => (
              <div key={a[0]} className={Row}>
                <div className={Container}>
                  <p>{a[0]}</p>
                  <NumberFormat
                    name={a[0]}
                    value={Number(form[a[0]])}
                    placeholder={a[0]}
                    suffix='%'
                    decimalSeparator=','
                    onValueChange={({ floatValue: value }) =>
                      setter({ target: { value, name: a[0] } })
                    }
                  />
                </div>
                <div className={Container}>
                  {a[1] && (
                    <>
                      <p>{a[1]}</p>
                      <NumberFormat
                        name={a[1]}
                        value={Number(form[a[1]])}
                        placeholder={a[1]}
                        suffix='%'
                        decimalSeparator=','
                        onValueChange={({ floatValue: value }) =>
                          setter({ target: { value, name: a[1] } })
                        }
                      />
                    </>
                  )}
                </div>
              </div>
            ))}
          <footer>
            <button
              disabled={!form.nome || !form.classificacao}
              onClick={(e) => {
                e.preventDefault();
                if (block.current) return;
                block.current = true;
                submit(form, etecStatus, form.id);
              }}
              id='btn_salvar_produto'
            >
              {form.id || form._id ? 'Salvar' : 'Criar'}
            </button>
          </footer>
        </form>
      </main>
      <MessageModal
        visible={pageError}
        type={'error'}
        message={pageError}
        title={
          form.id || form._id
            ? 'Falha ao atualizar o produto'
            : 'Falha ao criar o produto'
        }
        onDismiss={() => setPageError(null)}
      />
    </div>
  );
}

ProductEditor.defaultProps = {
  open: false,
  etecStatus: true,
  changeEtec: false,
  availableEtecs: [],
};

ProductEditor.propTypes = {
  form: propTypes.any.isRequired,
  setter: propTypes.func.isRequired,
  open: propTypes.bool,
  close: propTypes.func.isRequired,
  renderables: propTypes.array.isRequired,
  submit: propTypes.func.isRequired,
  etecStatus: propTypes.bool,
  changeEtec: propTypes.bool,
  availableEtecs: propTypes.arrayOf(propTypes.any),
};
